import { ReactElement } from 'react'

interface PriceProps {
  num: number | undefined
}
/*
NOTE: Unable to use the Intl package in Mitchell.
Possibly due to Windows bug / manifest issue: https://www.leereamsnyder.com/blog/ie-11-intl-is-not-available

const usFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const caFormatter = Intl.NumberFormat('fr-CA', {
  style: 'currency',
  currency: 'CAD', // @TODO: Verify CAD vs. USD for Canada
})

const mxFormatter = Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'USD', // @TODO: Peso or USD?
})
 */

const usFormatter = {
  format: (num: number) => {
    return `$${Number(num).toFixed(2)}`
  },
}

export const Price = (props: PriceProps): ReactElement => {
  //  const { selectedLanguage } = useContext(LanguageContext)

  const formatter = usFormatter
  /* if (selectedLanguage === 'es_MX') {
    formatter = mxFormatter
  } else if (selectedLanguage === 'fr_CA') {
    formatter = caFormatter
  } */

  const { num } = props
  if (num === undefined || Number.isNaN(num)) {
    return <>unavailable</>
  }
  return <>{formatter.format(num)}</>
}
